import { CarouselWrapper, prev, next, moveTo, switchTo, presentIndex } from "./components/CarouselWrapper.js";

export { CarouselWrapper, prev, next, moveTo, switchTo, presentIndex };


// WEBPACK FOOTER //
// ./src/pages/Artist/components/react-pretty-carousel-master/src/index.js